import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {RecordStatus} from "../../utilities/interfaces/RecordStatus";
import {recordStatusAPI} from "../../utilities/api/recordStatusApi";

// represents the shape of the slice in state
interface recordStatusState {
  recordStatuses: RecordStatus[];
  recordStatus: RecordStatus | null;
}

const initialState: recordStatusState = {
  recordStatuses: [],
  recordStatus: null,
};

const recordStatusSlice = createSlice({
  name: 'recordStatus',
  initialState,
  reducers: {

  },

  extraReducers(builder) {
    builder.addCase(getRecordStatuses.fulfilled, (state, action: any) => {
      state.recordStatuses = action.payload;
    });
  },
});

// Async thunk to fetch data from api
// under extra reducers on fulfilled the redux store is updated
export const getRecordStatuses = createAsyncThunk('getRecordStatus', async () => {
  return await recordStatusAPI.getRecordStatuses();
});

export default recordStatusSlice.reducer;
